import { LegislationEmployeeCostConfigurationTypeDTO } from "src/models/legislation-employee-cost-configuration-type/legislation-employee-cost-configuration-type-dto";
import { LegislationEmployeeCostConfigurationTypeSTO } from "src/models/legislation-employee-cost-configuration-type/legislation-employee-cost-configuration-type-sto";
import { BaseApiService } from "../base";

export class LegislationEmployeeCostConfigurationTypeApiService extends BaseApiService<
  LegislationEmployeeCostConfigurationTypeDTO,
  LegislationEmployeeCostConfigurationTypeSTO
> {
  constructor() {
    super({
      servicePath: "/LegislationEmployeeCostSection",
      loadItemsPath: "/GetLegislationEmployeeCostConfigurationTypes",
      saveItemsPath: "/SaveLegislationEmployeeCostConfigurationTypes",
    });
  }
}
